import { pick, get } from 'lodash';

function breadcrumbs() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./breadcrumbs.html'),
    scope: {},
    controller: 'BreadcrumbsController',
    controllerAs: 'vm',
    bindToController: {
      root: '@',
      currentTab: '=?',
      render: '=',
      changeLevel: '&?',
      app: '=?'
    }
  };
}

/**
   * @ngdoc controller
   * @name adjust.controller:BreadcrumbsController
   *
   * @description
   * All the functionality of the {@link adjust.directive:breadcrumbs breadcrumbs} directive
   *
   */
function BreadcrumbsController(
  $state,
  $uiRouterGlobals,
  $scope,
  $element,
  Breadcrumbs,
  Helper,
  App
) {
  'ngInject';
  var vm = this;

  vm.app = App.getCurrentApp();
  vm.history = [];

  vm.goTo = goTo;
  vm.goToTheRoot = goToTheRoot;

  Helper.ready(_renderBreadcrumbs);
  $scope.$watch('vm.render', _handleRender);
  $scope.$watch('vm.app', _handleAppChange);

  /**
   * @ngdoc method
   * @name _handleRender
   * @methodOf adjust.controller:BreadcrumbsController
   *
   * @description
   * Handle render state change
   *
   * @param {boolean} n new state
   * @param {boolean} o old state
   * @private
   */
  function _handleRender(n, o) {

    if (n === o || !n) { return; }

    _renderBreadcrumbs();

  }

  /**
   * @ngdoc method
   * @name _handleAppChange
   * @methodOf adjust.controller:BreadcrumbsController
   *
   * @description
   * Re-render breadcrumbs if app changes from the outside
   *
   * @param {Object} n new app
   * @param {Object} o old app
   * @private
   */
  function _handleAppChange(n, o) {

    if (n && o && n.id !== o.id) {
      _renderBreadcrumbs();
    }

  }

  /**
   * @ngdoc method
   * @name _renderBreadcrumbs
   * @methodOf adjust.controller:BreadcrumbsController
   *
   * @description
   * Render breadcrumbs for the current level
   *
   * @private
   */
  function _renderBreadcrumbs() {

    const params = pick($uiRouterGlobals.params, [
      'appToken',
      'trackerToken',
      'secret_ids',
      'grouping'
    ]);
    const currentTab = get(vm, 'currentTab.label', '');

    Breadcrumbs.buildTrackersHistory(params, vm.app.name, currentTab)
      .then(function(history) {
        vm.history = history;
        vm.render = false;
      });

  }

  /**
   * @ngdoc method
   * @name goTo
   * @methodOf adjust.controller:BreadcrumbsController
   *
   * @description
   * Redirects to the proper parent route
   *
   * @param {Object} route route object which tells where to go
   */
  function goTo(route) {
    if (vm.history.length <= 2) {
      return;
    }

    return vm.changeLevel({ route: route });
  }

  /**
   * @ngdoc method
   * @name goToTheRoot
   * @methodOf adjust.controller:BreadcrumbsController
   *
   * @description
   * Go to the root page
   */
  function goToTheRoot() {

    $state.go(vm.root === 'statistics' ? 'statisticsApps' : vm.root);

  }
}

export { breadcrumbs, BreadcrumbsController };
